// extracted by mini-css-extract-plugin
module.exports = {"animation":"flash-finish-985ef78d580c3d887e08c41fa2d8a830","wiggle":"flash-finish-63e9e004cd90ff61b92a8ce1008aabd8"};